export const setWebimLocalStorage = (id: number): void => {
  localStorage.setItem('WEBIM_VISITOR', JSON.stringify({ value: { id } }));
};
